import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@babel/polyfill'
import i18n from './plugins/i18n'
import config from './config'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'
import 'firebase/analytics'
import Promise from 'bluebird'

Vue.config.productionTip = false

firebase.initializeApp(config.firebaseConfig)
firebase.analytics()
// register with prototype so any other vue component can access
Vue.prototype.$firebase = firebase
Vue.prototype.$firebaseAuth = firebase.auth()
Vue.prototype.$firebaseDb = firebase.firestore()
Vue.prototype.$firebaseStorage = firebase.storage()
Vue.prototype.$firebaseFunc = firebase.app().functions('asia-northeast1')
// export so any other .js file can access
export const fb = firebase
export const db = firebase.firestore()
export const auth = firebase.auth()
export const storage = firebase.storage()
export const func = firebase.app().functions('asia-northeast1')

new Vue({
  router,
  store,
  vuetify,
  i18n,
  created() {
    this.$store.commit('appLoading', true)
    // listening on auth state change from firebase
    // read more here: https://firebase.google.com/docs/reference/android/com/google/firebase/auth/FirebaseAuth.AuthStateListener
    this.$firebaseAuth.onAuthStateChanged((user) => {
      // eslint-disable-next-line
      console.info('user state changed', user)
      if (user) {
        // user just sign-in (or just resumed session)
        // performing auto-sing in
        // pushing user to dashboard
        // update language and setting
        this.$firebaseAuth.currentUser
          .getIdTokenResult(true)
          .then((idTokenResult) => {
            const claims = idTokenResult.claims
            // eslint-disable-next-line
            console.info('all claims', claims)

            if (!claims.role) {
              // user login but still has not yet setup
              this.$store.commit('account/setCurrentToWait')
              this.$store.commit('appLoading', false)
            } else {
              // set all the claims first (must be first)
              this.$store.commit('account/setClaim', claims)

              const promises = []
              promises.push(
                ...[
                  // TODO: get profile
                  this.$store.dispatch('account/subscribeProfile'),
                  this.$store.dispatch('product/subscribeProducts'),
                  this.$store.dispatch('tenant/subscribeTenant'),
                  this.$store.dispatch('order/subscribeOrders'),
                  this.$store.dispatch('bill/getRecentBills'),
                  this.$store.dispatch('employee/subscribeEmployee'),
                  this.$store.dispatch('deliveryAgent/subscribeDeliveryAgents'),
                  this.$store.dispatch('subProduct/subscribeSubProducts')
                ]
              )
              Promise.all(promises)
                .catch((error) => {
                  // eslint-disable-next-line
                  console.error(error)
                })
                .finally(() => {
                  this.$store.commit('appLoading', false)
                  // eslint-disable-next-line
                  // console.warn('Store to Debug', this.$store)
                  if (this.$router.currentRoute.name === 'Landing') {
                    this.$router.push({ name: 'Home' })
                  }
                })
            }
          })
          .catch((error) => {
            // TODO: sign out
            // eslint-disable-next-line
            console.warn('Error caught here', error.message)
            // eslint-disable-next-line
            console.error(error)
            this.$store.commit('appLoading', false)
            if (this.$router.currentRoute.name !== 'Landing') {
              this.$router.push({ name: 'Landing' })
            }
          })
      } else {
        // user just sign-out (or just invalidate the local storage)
        // push user back to landing
        this.$store.commit('appLoading', false)
        if (this.$router.currentRoute.name !== 'Landing') {
          this.$router.push({ name: 'Landing' })
        }
      }
    })
  },
  render: (h) => h(App)
}).$mount('#app')
